<template>
  <div class="nsale_">
    <div class="outer" v-for="(item, index) in list" :key="index">
      <div class="inner" :class="{ move: candelete == index }">
        <div class="in_1">
          <div class="head">
            {{ item.name.slice(0, 1) }}
          </div>
        </div>
        <div class="in_2" @click="toDetail(index, item)">
          <div class="in_2Left">
            <p class="in_txt in_txt1">{{ item.name }}</p>
            <p class="in_txt">账号：{{ item.loginName }}</p>
          </div>
          <img
            class="in_2img"
            src="../../../assets/image/nsale/arrow.png"
            alt="arr"
          />
        </div>
        <div class="in_3" @click="handleDelete(item)">删除</div>
      </div>
    </div>
    <div v-if="!nomore" class="nomore" @click="getMore">点击加载更多</div>
    <div v-if="nomore" class="nomore">没有更多了</div>
    <div v-if="list.length === 0" class="nodata">暂无数据</div>
  </div>
</template>

<script>
import api from '@/utils/api'
export default {
  data () {
    return {
      nomore: false,
      clientNum: {}, // 记录开始滑动（x1）,结束滑动（x2）的鼠标指针的位置
      candelete: {}, // 滑动的item
      colorList: ['#34D54B', '#FFA749', '#F7E125'],
      list: [],
      pagation: {
        pageNum: 1,
        pageSize: 10,
        pages: 0,
        total: 0
      },
      clientHeight: 0, // 可视区的高度
      scrollTop: 0, // 滚动条滚动时，距离顶部的距离
      scrollHeight: 0 // 滚动条的总高度
    }
  },
  created () {
    window.addEventListener('scroll', this.listenerFunction)
  },
  destroyed () {
    window.removeEventListener('scroll', this.listenerFunction)
  },
  mounted () {
    this.hideOptionMenu()
    this.userId = this.$route.query.userId
    this.getToken().then(() => {
      this.getUserListByUserId(false)
    })
  },
  methods: {
    getMore(){
      if (this.pagation.pageNum < this.pagation.pages) {
        this.pagation.pageNum++
        this.getUserListByUserId(true)
      } else {
        this.nomore = true
      }
    },
    listenerFunction () {
      debugger
      let timer = null
      this.scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop // 可视区的高度
      this.clientHeight =
        document.documentElement.clientHeight || document.body.clientHeight // 滚动条滚动时，距离顶部的距离
      this.scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight // 滚动条的总高度

      if (this.scrollTop + this.clientHeight >= this.scrollHeight) {
        timer = setTimeout(() => {
          // 延迟500ms加载数据
          if (this.pagation.pageNum < this.pagation.pages) {
            this.pagation.pageNum++
            this.getUserListByUserId(true)
          } else {
            this.nomore = true
          }
        }, 500)
      }
    },
    hideOptionMenu () {
      document.addEventListener(
        'WeixinJSBridgeReady',
        function onBridgeReady () {
          WeixinJSBridge.call('hideOptionMenu')
        }
      )
    },
    wxpay () {
      var vm = this
      if (typeof WeixinJSBridge === 'undefined') {
        // 微信浏览器内置对象。参考微信官方文档
        if (document.addEventListener) {
          document.addEventListener(
            'WeixinJSBridgeReady',
            vm.onBridgeReady(),
            false
          )
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', vm.onBridgeReady())
          document.attachEvent('onWeixinJSBridgeReady', vm.onBridgeReady())
        }
      } else {
        vm.onBridgeReady()
      }
    },
    onBridgeReady: function () {
      WeixinJSBridge.call('hideOptionMenu')
    },
    getToken () {
      return api.getToken({ userId: this.userId }).then(res => {
        localStorage.setItem('token', res.data.content)
      })
    },
    getUserListByUserId (flag) {
      if (!flag) {
        this.pagation.pageNum = 1
        this.list = []
        this.nomore = false
      }
      api.getUserListByUserId(this.pagation, {
        teamTemplateId:this.$route.query.teamTemplateId,
        searchChars:this.$route.query.searchChars
      }).then(res => {
        if (res.data.content) {
          this.pagation.total = res.data.content.total
          this.pagation.pages = Math.ceil(
            res.data.content.total / this.pagation.pageSize
          )
          if (!flag) {
            this.list = res.data.content.list
          } else {
            this.list = this.list.concat(res.data.content.list)
          }
        }
      })
    },
    updateUser (data) {
      api.updateUser(data).then(res => {
        this.showToast('操作成功')
        this.getUserListByUserId()
      })
    },
    showToast (text) {
      this.$createToast({
        txt: text,
        time: 1000,
        type: 'txt'
      }).show()
    },
    handleDelete (item) {
      console.log('删除', item)
      let data = {
        id: item.id,
        forbiddenType: '1',
        deleteFlag: '1'
      }
      this.updateUser(data)
    },
    toDetail (index, item) {
      if (this.$route.query.type === 'C') {
        this.$router.push({ path: `/nsale/cDetail/${item.id}`, params: item })
        return
      }
      this.$router.push({ path: `/nsale/detail/${item.id}`, params: item })
    },
    touchStart (index) {
      let touchs = event.changedTouches[0]
      // 记录开始滑动的鼠标位置
      this.clientNum.x1 = touchs.pageX
    },
    touchEnd (index) {
      let touchs = event.changedTouches[0]
      // 记录结束滑动的鼠标位置
      this.clientNum.x2 = touchs.pageX
      // 判断滑动距离大于50，判定为滑动成功，否则失败
      if (
        this.clientNum.x2 < this.clientNum.x1 &&
        Math.abs(this.clientNum.x1) - Math.abs(this.clientNum.x2) > 50
      ) {
        event.preventDefault()
        this.candelete = index
      } else if (
        this.clientNum.x2 > this.clientNum.x1 &&
        Math.abs(this.clientNum.x2) - Math.abs(this.clientNum.x1) > 50
      ) {
        event.preventDefault()
        this.candelete = {}
      }
    }
  }
}
</script>

<style scoped lang="scss">
.nsale_ {
  font-family: PingFang SC;
  background: rgba(245, 245, 245, 1);
  min-height: 100vh;
  .outer {
    overflow: hidden;
    background: #fff;
    .inner {
      display: flex;
      width: 443px;
      .in_1,
      .in_2,
      .in_3 {
        height: 75px;
      }
      .in_1 {
        width: 68px;
        display: flex;
        align-items: center;
        justify-content: center;
        .head {
          width: 45px;
          height: 45px;
          line-height: 45px;
          font-weight: bold;
          background: #fff6f5;
          border-radius: 50%;
          font-size: 20px;
          color: #ff513d;
        }
      }
      .in_2 {
        width: 307px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 10px;
        .in_2Left {
          text-align: left;
        }
        .in_txt {
          font-size: 13px;
          color: rgba(102, 102, 102, 1);
        }
        .in_txt1 {
          font-size: 15px;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
          margin-bottom: 10px;
        }
        .in_2img {
          height: 13px;
          width: auto;
        }
      }
      .in_3 {
        width: 68px;
        line-height: 75px;
        background: rgba(204, 204, 204, 1);
        font-size: 12px;
        color: rgba(255, 255, 255, 1);
      }
    }
    .inner.move {
      transform: translateX(-68px);
    }
  }
}

.null_ {
  padding-top: 70px;
  font-size: 13px;
  color: rgba(153, 153, 153, 1);
  img {
    height: 130px;
    width: auto;
  }
  .nullTxt {
    width: 246px;
    line-height: 20px;
    margin: 10px auto 0;
  }
}
.nomore {
  font-size: 13px;
  padding: 10px 0;
}
.nodata {
  font-size: 20px;
  height: 100vh;
  line-height: 100vh;
}
</style>
